import React from "react";
import Helmet from 'react-helmet'
import Layout from "../components/layout";
import { withPrefix } from 'gatsby'
import { Link } from "gatsby"
import { Preloader, Placeholder } from 'react-preloading-screen';
import Icon from '../components/icons';
import AnimatedNumber from "animated-number-react";
// import VisibilitySensor from "react-visibility-sensor";
import ScrollAnimation from 'react-animate-on-scroll';
import ImpactStories from "../components/impact-story-card";
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import Vimeo from '@u-wave/react-vimeo';

// import WhatDoesItTake from '../_images/homepage/what-does-it-take.png';

import plannedGiving from '../_images/homepage/planned-giving.svg';
import alumniDonors from '../_images/homepage/alumni-donors.svg';
import scholarshipsAwarded from '../_images/homepage/scholarships-awarded.svg';
import facStaffDonors from '../_images/homepage/fac-staff-donors.svg';

const responsive = {
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 3,
    // slidesToSlide: 2 // optional, default to 1.
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 2,
    // slidesToSlide: 2 // optional, default to 1.
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
    // slidesToSlide: 1 // optional, default to 1.
  }
};

export default class Index extends React.Component {
  

  constructor(props) {
    super(props);
    this.state = {
      planned: 0,
      alumni: 0,
      scholarships: 0,
      facstaff: 0,
      individualdonors: 0
    };
    // this.onVisible = this.onVisible.bind(this);
    this.donorImpactVisible = this.donorImpactVisible.bind(this);
    this.scrollElement = React.createRef();
    this.scrollTrigger = React.createRef();
  }

  decimalFormatValue = (value) => Number(value).toFixed(2);
  numberFormatValue(value) {
    value = Number(value).toFixed(0);
    value = Number(value).toLocaleString();
    return value;
  }


  // onVisible = (isVisible) => {
    
  //   if(isVisible){
  //     // var BodyCams = document.querySelector("#body-cams");

  //     // const stats = BodyCams.querySelectorAll('.value');
  //     // stats.forEach(function(stat) {
  //     //   stat.style.width = stat.dataset.width + '%';
  //     // });

  //     // const statsInner = BodyCams.querySelectorAll('.value-inner');
  //     // statsInner.forEach(function(statInner) {
  //     //   statInner.style.display = 'inline';
  //     //   statInner.classList.add('animate__animated', 'animate__fadeIn','animate__delay-1s');
  //     // });

  //     // const icons = BodyCams.querySelectorAll('.icon-wrap');
  //     // icons.forEach(function(icon) {
  //     //   icon.style.display = 'block';
  //     //   icon.classList.add('animate__animated', 'animate__rotateIn','animate__delay-1s');
  //     // });

  //     this.setState({
  //       planned: 79,
  //       alumni: 40000,
  //       scholarships: 20,
  //       facstaff: 2000,
  //     });
  //     // console.log('hello');
  //   }
  // }

  donorImpactVisible = () => {
    this.setState({
      planned: 87,
      alumni: 42178,
      scholarships: 20.7,
      facstaff: 2000,
      individualdonors: 71396,
    });
  }

  scrollDonors = () => {

    // console.log('hello');
    console.log(this.scrollElement.current.scrollLeft);
    this.scrollElement.current.scrollLeft = this.scrollElement.current.scrollLeft + 400

  }

  render() {
    
    return (
      <Preloader>
      <Layout>
        <Helmet>
          <body className="intro" />
        </Helmet>
        <section id="hero-banner">
          <div className="hero-banner-content">
            <div className="wrap">
              {/* <img src={WhatDoesItTake} alt="What does it take to make a difference in the life of a  Cal State Fullerton student? It takes a Titan like you." id="what-does-it-take-graphic" /> */}
              <div id="heading-text" className="text-white text-shadow">
                <span className="top-text text-sans-serif text-weight-700 text-uppercase animated fadeInUp">What does it take to make a difference in the life of a  Cal State Fullerton student?</span>
                <span className="bottom-text text-serif animated fadeIn slower delay-1s">It takes a Titan like <em>you</em></span>
              </div>
              <div className="scroll__down">
                <span className="scroll__mouse">
                  <span className="scroll__wheel"></span>
                </span>
              </div>
            </div>
          </div>
          <video id="hero-banner-video" autoPlay="autoplay" loop muted="muted" playsInline title="Intro Video">
            <source src={ withPrefix('/_video/homepage/resilience.webm') } type="video/webm; codecs=vp9,vorbis" />
            <source src={ withPrefix('/_video/homepage/resilience.mp4') } type="video/mp4" />
            <track kind="captions" srcLang="en" label="English" src={ withPrefix('/_video/homepage/resilience.vtt') } />
          </video>
        </section>
        <section id="intro" className="top-line bottom-line">
          <div className="wrap small">
            <ScrollAnimation animateOnce={true} animateIn="fadeInUp">
            <p>To empower the potential of its students, Cal State Fullerton publicly launched its first-ever comprehensive philanthropic campaign in March 2020. Thousands of donors, alumni, faculty, staff, students, foundations and corporations answered the call — helping us raise more than <strong>$270 million</strong>.</p>
            </ScrollAnimation>

            <ScrollAnimation animateOnce={true} animateIn="fadeInUp">
            <p className="text-size-5xl text-serif"><em>Thank you.</em></p>
            </ScrollAnimation>
            
          </div>
          <div className="wrap m-t-50">
          <ScrollAnimation animateOnce={true} animateIn="fadeInUp">
            <Vimeo
              autoPlay="true"
              video="801083904"
              responsive
              showTitle="false"
              showByline="false"
              showPortrait="false"
            />
            </ScrollAnimation>
          </div>
        </section>
        <section id="stories" className="top-line">
          <div className="wrap small p-b-50">
            <ScrollAnimation animateOnce={true} animateIn="fadeInUp">
            <h2 className="text-white">Your Generosity Is Making a Difference</h2>
            </ScrollAnimation>
            <ScrollAnimation animateOnce={true} animateIn="fadeInUp">
            <p>Students share, in their own words, how they were empowered by their Titan education. Thanks to you, our generous community of donors, these students discovered their passions and leadership potential in academics, arts and athletics.</p>
            </ScrollAnimation>
          </div>
          <ScrollAnimation animateOnce={true} animateIn="fadeInUp">
          <div id="impact-stories">
            <ImpactStories />
          </div>
          </ScrollAnimation>
        </section>
        <section id="why-i-give" className="top-line bottom-line">
          <div className="wrap small p-b-50">
            <ScrollAnimation animateOnce={true} animateIn="fadeInUp">
            <h2>Why I Give</h2>
            </ScrollAnimation>
            <ScrollAnimation animateOnce={true} animateIn="fadeInUp">
            <p>Cal State Fullerton supporters share their reasons for giving to the “It Takes a Titan” campaign.</p>
            </ScrollAnimation>
          </div>
          <ScrollAnimation animateOnce={true} animateIn="fadeInRight">
          <div id="donor-quotes-container">
            {/* <button id="donor-quotes-scroll-trigger" onClick={this.scrollDonors} ref={this.scrollTrigger}><Icon name="arrow-right" alt="Scroll Right"  /></button> */}
            <Carousel
              swipeable={true}
              draggable={false}
              showDots={false}
              responsive={responsive}
              ssr={true} // means to render carousel on server-side.
              infinite={false}
              autoPlay={false}
              autoPlaySpeed={1000}
              keyBoardControl={true}
              containerClass="carousel-container"
              // removeArrowOnDeviceType={["tablet", "mobile"]}
              deviceType={this.props.deviceType}
              itemClass="donor-quote"
            >
              <div className="donor-quote-inner">
                <blockquote>
                  <p>The support I give to Cal State Fullerton is about trying to pass on that hope to students — so that they can transform their life into anything that they want it to be.</p>
                  <cite>Terry Giles ’70 (B.A. speech communication)</cite>
                </blockquote>
              </div>
              <div className="donor-quote-inner">
                <blockquote>
                  <p>“When you watch students get emotional because they never would have made it to where they are without the opportunities afforded them by the university, it confirms why you give back.” </p>
                  <cite>Jeffrey Van Harte ’80 (B.A. business administration-finance) </cite>
                </blockquote>
              </div>
              <div className="donor-quote-inner">
                <blockquote>
                  <p>“Our partnership with CSUF is mission-aligned, and the projects we’re supporting are focused on providing our community with equal access to opportunity...”</p>
                  <cite>Maya Patel, executive chair of the Tarsadia Foundation</cite>
                </blockquote>
              </div>
              <div className="donor-quote-inner">
                <blockquote>
                  <p>I hope I’m setting an example. To supply the funds to advance our understanding of the world — that is amazing joy … real joy.</p>
                  <cite>Nicholas Begovich (1921-2020)</cite>
                </blockquote>
              </div>
              <div className="donor-quote-inner">
                <blockquote>
                  <p>I want to help students. It’s rewarding that I play a role in their lives.</p>
                  <cite>Dan Black ’67 (B.S. physics)</cite>
                </blockquote>
              </div>
              <div className="donor-quote-inner">
                <blockquote>
                  <p>We are proud to help the College of Education offer innovative, high-quality and inclusive educational opportunities.</p>
                  <cite>Bill Cheney, president and CEO, SchoolsFirst Federal Credit Union</cite>
                </blockquote>
              </div>
              <div className="donor-quote-inner">
                <blockquote>
                  <p>I’ve had a wonderful career as a faculty member at CSUF, and I wanted to pay it forward in a meaningful way.</p>
                  <cite>Marc Dickey, professor emeritus of music</cite>
                </blockquote>
              </div>
              <div className="donor-quote-inner">
                <blockquote>
                  <p>Helping Titans is so important in putting them on the road to success, so they can better our community and world.</p>
                  <cite>Karl Freels ’12, ’17 (B.A., M.A. history)</cite>
                </blockquote>
              </div>
              
              <div className="donor-quote-inner">
                <blockquote>
                  <p>We hope our support motivates students to successfully complete their studies.</p>
                  <cite>Darrell ’85 and Vicky Jodoin</cite>
                </blockquote>
              </div>
              <div className="donor-quote-inner">
                <blockquote>
                  <p>My gift will help ensure that the Fullerton Arboretum will continue to support student success, cutting-edge research and real-world conservation.</p>
                  <cite>Francis Colwell and Sandy Koizumi</cite>
                </blockquote>
              </div>
              <div className="donor-quote-inner">
                <blockquote>
                  <p>We have been contacted by so many students who have thanked us for our support.</p>
                  <cite>William ’76, ’79, ’83 and Paula Purpura ’77, ’83</cite>
                </blockquote>
              </div>
              <div className="donor-quote-inner">
                <blockquote>
                  <p>After retiring from working in the public school system, I am in a position to support other students through scholarships.</p>
                  <cite>Jennifer ’87 and Mark Shepard</cite>
                </blockquote>
              </div>
              <div className="donor-quote-inner">
                <blockquote>
                  <p>My wife, Sandy DeAngelis, and I are total believers in the future of Cal State Fullerton.</p>
                  <cite>Ed Trotter, professor emeritus of communications</cite>
                </blockquote>
              </div>
              </Carousel>
          </div>
          </ScrollAnimation>
          <p className="p-t-100">
            <Link to="/why-i-give" className="button pill titanBlue">Read More</Link>
          </p>
        </section>
        <section id="donor-impact" className="top-line">
          {/* <VisibilitySensor onChange={this.onVisible}> */}
          <div className="wrap">
            <ScrollAnimation animateOnce={true} animateIn="fadeInUp" afterAnimatedIn={this.donorImpactVisible}>
            <h2 className="text-white">Donor Impact By the Numbers</h2>
            </ScrollAnimation>
  
            <div className="row m-t-50">
              <div className="col-3 col-6-sm">
                <ScrollAnimation animateOnce={true} animateIn="fadeInUp">
                <span className="impact-stat">
                  <img src={plannedGiving} alt="" />
                  <span className="impact-number">$<AnimatedNumber value={this.state.planned}  delay={0} formatValue={this.numberFormatValue} duration={2000} />M</span>
                  <span className="impact-desc">in Planned Giving Commitments</span>
                </span>
                </ScrollAnimation>
              </div>
              <div className="col-3 col-6-sm">
                <ScrollAnimation animateOnce={true} delay={500} animateIn="fadeInUp">
                <span className="impact-stat">
                  <img src={alumniDonors} alt="" />
                  <span className="impact-number"><AnimatedNumber value={this.state.alumni}  delay={500} formatValue={this.numberFormatValue} duration={2000} /></span>
                  <span className="impact-desc">Alumni Donors</span>
                </span>
                </ScrollAnimation>
              </div>
              <div className="col-3 col-6-sm">
                <ScrollAnimation animateOnce={true} delay={1000} animateIn="fadeInUp">
                <span className="impact-stat">
                  <img src={scholarshipsAwarded} alt="" />
                  <span className="impact-number">$<AnimatedNumber value={this.state.scholarships}  delay={1000} formatValue={this.numberFormatValue} duration={2000} />M</span>
                  <span className="impact-desc">in Scholarships Awarded</span>
                </span>
                </ScrollAnimation>
              </div>
              <div className="col-3 col-6-sm">
                <ScrollAnimation animateOnce={true} delay={1500} animateIn="fadeInUp">
                <span className="impact-stat">
                  <img src={facStaffDonors} alt="" />
                  <span className="impact-number"><AnimatedNumber value={this.state.individualdonors}  delay={1500} formatValue={this.numberFormatValue} duration={2000} /></span>
                  <span className="impact-desc">Individual Donors</span>
                </span>
                </ScrollAnimation>
              </div>
            </div>
          </div>
          {/* </VisibilitySensor> */}
        </section>
        <section id="end-cta">
          <div className="wrap small">
            <ScrollAnimation animateOnce={true} animateIn="fadeInUp">
            <h2>Continue Making a Difference</h2>
            </ScrollAnimation>
            <ScrollAnimation animateOnce={true} animateIn="fadeInUp">
            <p>Cal State Fullerton is the catalyst for Titan-sized transformations, inspiring students’ paths, launching careers and improving lives. The “It Takes a Titan” philanthropic campaign is an opportunity for you to be the difference in a Titan’s life.</p>
            <a href="#" className="button pill titanBlue">Give Now</a>
            </ScrollAnimation>
          </div>
        </section>
      </Layout>
      <Placeholder>
      <div className="loader">
        <div className="text">
          <svg id="itat_emblem" className="animated fadeIn" xmlns="http://www.w3.org/2000/svg" width="167.4" height="167.4" viewBox="0 0 167.4 167.4">
            <path d="M85.3 164.9h-.5.5m0 0c7.5-.1 14.7-1.2 21.5-3.2h-.4c-6.7 2-13.8 3.1-21.1 3.2m-.5 0h-.9.9"/><circle cx="83.7" cy="83.7" r="81.2" fill="none" stroke="#fff" strokeWidth="5" strokeMiterlimit="10"/><path d="M165.3 83.7c0 44.9-36.4 81.2-81.2 81.2S2.9 128.5 2.9 83.7 39.2 2.5 84 2.5s81.3 36.4 81.3 81.2" fill="#bf5f16"/><path d="M164.7 93.1c.4-3.1.5-6.2.5-9.3 0-44.9-36.4-81.2-81.2-81.2C39.1 2.6 2.8 39 2.8 83.8c0 3.2.2 6.3.5 9.3C7.6 56.4 36.1 27.2 72.5 22c-29.3 5.5-51.4 31.1-51.4 61.9 0 34.8 28.2 63 63 63s63-28.2 63-63c0-30.8-22.2-56.5-51.4-61.9 36.2 5.2 64.8 34.4 69 71.1" fill="#f47920"/><path className="burst" d="M83.2 53.5l4.1-29.2v29.5l8.1-28.4-4.1 29.2 12-26.9L95.1 56l15.7-25-12 27 18.9-22.6-15.6 25L124 40.6l-19 22.6 24.5-16.5-21.9 19.8 26.5-13L109.6 70l28.1-9.1-26.6 12.9 29.1-5.1-28.1 9.1 29.5-1.1-29 5.2 29.3 3-29.5 1 28.7 7.2-29.4-3.1 27.4 11-28.7-7.1 25.6 14.7-27.4-11 23.3 18.1-25.6-14.7 20.6 21.2-23.3-18.2 17.4 23.9-20.5-21.3 13.8 26.1L97 108.8l10.1 27.7-13.9-26 6.2 28.8-10.1-27.7 2.1 29.4-6.1-28.8-2.1 29.4-2-29.4L75 141l2.1-29.4L67 139.3l6.2-28.8-13.9 26 10.1-27.7-17.3 23.9 13.8-26.1-20.5 21.3L62.8 104l-23.2 18.2L60.1 101l-25.6 14.7 23.3-18.1-27.4 11L56 93.9 27.3 101l27.4-11-29.3 3.1L54 85.9l-29.5-1 29.4-3-29.1-5.2 29.5 1.1-28.1-9.1 29.1 5.1-26.6-12.9L56.8 70 32.3 53.5l26.6 13-22-19.8 24.5 16.5-19-22.6 21.9 19.8-15.6-25L67.6 58l-12-27 15.7 25-8.2-28.3 12 26.9L71 25.4l8.1 28.4V24.3l4.1 29.2z" fill="#fff"/><path d="M163.6 99.2c-.9-3.3-2.5-7.7-2.5-7.7l-7.2.1-5.5-8.8s-1.2 2.3-2.5 4.8l-36.8-39.8c-5.7 4.6-37.7 26.3-37.7 26.3l-6.9-2.6-2.9 3.5-8.1-7.3-14.3 6.2s-5.5 6.2-7.8 9.8c-2.5 3.8-9.1 12.8-9.1 12.8L19 92.8s-2.2 4.3-3.2 6.5c-.9 2-1.8 3.6-3.1 5.1-1.7 2.2-3.5 4.3-5.1 6.9 9 25 30 44.4 56.1 51.1h.1c1.3.3 2.6.6 3.8.9 1.2.2 2.4.5 3.7.7.2 0 .5.1.7.1 1.1.2 2.3.3 3.4.4h.3l3.6.3c.3 0 .7 0 1 .1 1.2.1 2.4.1 3.6.1h.3c.8 0 1.7 0 2.5-.1 6.8-.3 13.4-1.3 19.7-3.2h.3c.4-.1.8-.2 1.2-.4.2-.1.3-.1.5-.2 1.2-.4 2.3-.8 3.5-1.2h.1c26.3-9.6 46.1-32.4 51.7-60.4-.1 0-.1-.2-.1-.3z" fill="#002a54"/><path className="st5" d="M96.9 109.7l1.8-34.9 6.2 12.3 2.6-24.2 8.3-.4-7.2-6.5S77.7 75.7 76.4 78c-1.6 2.9-.7 3.8-3.1 3.4-1.7-.2-7.2-4.6-7.2-4.6l-2.4 12.1s3.5-3.3 6.3-1.1c2.5 2 9.5 8.9 9.5 8.9l-2.8-10.3s12.1 5.3 13.1 6.7c2.5 3.5 7.1 16.6 7.1 16.6"/><path className="st6" d="M73.2 107.1c-1.3-1.2-2.7-2.3-3.9-3.7-1.5-1.7-5.7-4.2-8.1-5.6.4 3.5 0 6.9 1.4 9.5.9 1.7 2.4 2.3 3.4 3.7 1.1 1.5 1.4 3.4 2.4 5.1 2.1 3.5 4.4 5.7 6 10.2 1.3 3.4 2.2 7.9 2.9 11.1 0-4.7-.6-28-.6-28s-2.9-1.8-3.5-2.3M47.4 78l9 17.2-3.9-22.5-5.1 5.3zm70.9 4.7c1.2-.3 1.7 3.5 1.9 4.7.4 2.5.4 4.7 1.3 7 .8 2 2.6 1.2 3.5 2.7.1-.2.1-.3.2-.5-.6-3.1-2.1-6.9-2.1-9.2 0-1.8-1.1-5.3-1.1-5.3s-5.3-8.2-6.5-9.4c1.8 6.4-4.1 12.9-3.7 17.9.2-.9 5.8-7.7 6.5-7.9"/><path className="st5" d="M22.6 131.8s4.9-18.9 9.2-16.7c4.1 2.1 9.8 13.3 10.2 14-.2-1-2.9-16.3-4.2-24.1-1.1-6.8 1-22.4 1-22.4s-11 23.7-13.2 25.2c-1.4 1-5.3-4.7-5.3-4.7l-8.9 17c1.1 2.2 2.3 4.3 3.6 6.4 1-.5 1.8-.9 2.6-.9 2.4-.1 5 6.2 5 6.2zm124.8-38.4s-9.3 18.4-11.3 19.9c-1.2.9-4.7-4.3-4.7-4.3l-5.4 10.4c.3.9-3.8 10-3.5 10.8s.6 1.5.9 2.2c2.1-1.8 4-3.1 5.6-3.2 2.1-.1 4.5 5.6 4.5 5.6s4.4-17.1 8.2-15.1c2.9 1.5 6.8 8.2 8.4 11.2.1-.2.3-.4.4-.6-.8-4.3-2.5-14.1-3.4-19.6-1-6.1.3-17.3.3-17.3z"/><path className="st6" d="M159 96.6l-4.6 4.6 5.8 11c.4-1 .7-2 1-3L159 96.6z"/></svg>
            <span className="animated fadeIn">Loading...</span>
        </div>
      </div>
      </Placeholder>
      </Preloader>
    );
  }
}